import { useTranslation } from "react-i18next";
import CreateUpdateSaleVat from "../SalesVAT/components/CreateUpdateSaleVat";
import { Space } from "antd";
import RemoveButton from "../SalesVAT/components/RemoveButton";

export default function useSalesVATTableColumns(refetch: any) {
  const { t } = useTranslation();

  return [
    {
      title: t("Client"),
      dataIndex: "client",
      key: "client",
      render: (_text: unknown, record: Record<string, any>) => {
        return record?.clientVatType ? (
          <span>{`${record?.clientVatType?.code} - ${record?.clientVatType?.name}`}</span>
        ) : (
          "*"
        );
      },
    },
    {
      title: t("Product"),
      dataIndex: "product",
      key: "product",
      render: (_text: unknown, record: Record<string, any>) => {
        return record?.productType ? (
          <span>{`${record?.productType?.code} - ${record?.productType?.name}`}</span>
        ) : (
          "*"
        );
      },
    },
    {
      title: t("VAT"),
      dataIndex: "vat",
      key: "vat",
      render: (_text: unknown, record: Record<string, any>) => {
        return record?.vat ? <span>{`${record?.vat?.code} - ${record?.vat?.name}`}</span> : "*";
      },
    },
    {
      title: t("Counterpart code"),
      dataIndex: "counterpartCode",
      key: "counterpartCode",
    },
    {
      dataIndex: t("Action"),
      key: "action",
      title: "Action",
      align: "center",
      width: "100px",
      render: (_text: unknown, record: Record<string, any>) => {
        return (
          <Space size="small" direction="horizontal" className="centered">
            <>
              {record?.editable && <RemoveButton id={record.id} refetch={refetch} />}
              <CreateUpdateSaleVat
                onlyCanEditCounterpart={!record?.editable}
                id={record.id}
                refetch={refetch}
              />
            </>
          </Space>
        );
      },
    },
  ];
}
